module.exports = __webpack_public_path__ + "img/new-adra-logo.dd6a5d98.png";